import styled from 'styled-components';
import { Button } from 'pages/lectures/styles';

// position: relative é obrigatório: é o que ancora a NewTag posicionada em absolute
export const NotesButtonStyled = styled(Button)`
  position: relative;
`;

export const NewTag = styled.span`
  position: absolute;
  top: -8px;
  right: -6px;

  display: inline-flex;
  align-items: center;

  padding: 1px 6px;

  border-radius: 8px;
  background: var(--Mensagens-Danger, #ee3c3e);
  color: var(--escala-de-cinza-0, #fff);

  font-family: Manrope;
  font-size: 10px;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
`;

export const DrawerPanel = styled.aside<{ open: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 200000;

  width: 650px;
  max-width: 100vw;

  display: flex;
  flex-direction: column;

  background: var(--escala-de-cinza-0, #fff);
  box-shadow: -6px 0px 16px 0px rgba(0, 0, 0, 0.08);

  transform: translateX(${({ open }) => (open ? '0' : '100%')});
  visibility: ${({ open }) => (open ? 'visible' : 'hidden')};
  transition:
    transform 0.3s ease,
    visibility 0.3s ease;

  /* Em telas pequenas o painel vira um bottom sheet, mantendo o topo da prova visível */
  @media screen and (max-width: 768px) {
    width: 100%;
    top: auto;
    height: min(72vh, 640px);
    border-radius: 16px 16px 0 0;
    box-shadow: 0px -6px 16px 0px rgba(0, 0, 0, 0.08);
    transform: translateY(${({ open }) => (open ? '0' : '100%')});
  }
`;

// Alça de redimensionamento: borda esquerda no desktop (ajusta largura) e borda
// superior no mobile/bottom sheet (ajusta altura)
export const ResizeHandle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 1;

  width: 12px;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: ew-resize;
  /* arrastar a alça não pode disparar scroll/gestos da página */
  touch-action: none;
  -webkit-user-select: none;
  user-select: none;

  &::after {
    content: '';
    width: 4px;
    height: 48px;
    border-radius: 2px;
    background: var(--escala-de-cinza-20, #d6d6d6);
    transition: background 0.2s ease;
  }

  &:hover::after,
  &:focus-visible::after {
    background: var(--Primary-Purple, #5768ff);
  }

  &:focus-visible {
    outline: none;
  }

  @media screen and (max-width: 768px) {
    right: 0;
    bottom: auto;

    width: 100%;
    height: 14px;

    cursor: ns-resize;

    &::after {
      width: 48px;
      height: 4px;
    }
  }
`;

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 16px;
  border-bottom: 1px solid var(--escala-de-cinza-10, #efefef);
`;

export const DrawerTitle = styled.h3`
  margin: 0;
  color: var(--escala-de-cinza-90, #101010);

  font-family: 'DM Sans';
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;

  border: none;
  background: none;
  cursor: pointer;

  transition: all 0.3s ease;

  &:hover {
    filter: opacity(0.7);
  }
`;

export const DrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 12px;

  padding: 16px;
  overflow: hidden;
`;

export const DrawerHint = styled.p`
  margin: 0;
  color: var(--escala-de-cinza-60, #666);

  font-family: Manrope;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`;

export const DrawerWarning = styled.p`
  margin: 0;
  padding: 8px 12px;

  border-radius: var(--radius-md, 8px);
  background: rgba(238, 60, 62, 0.08);
  color: var(--Mensagens-Danger, #ee3c3e);

  font-family: Manrope;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`;

export const NotesTextArea = styled.textarea<{ $visible?: boolean }>`
  display: ${({ $visible = true }) => ($visible ? 'block' : 'none')};
  flex: 1;
  width: 100%;
  resize: none;

  padding: 12px;

  border-radius: var(--radius-md, 8px);
  border: 1px solid var(--escala-de-cinza-20, #d6d6d6);
  background: var(--escala-de-cinza-0, #fff);
  color: var(--escala-de-cinza-90, #101010);

  font-family: Manrope;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;

  outline: none;

  &:focus {
    border-color: var(--Primary-Purple, #5768ff);
  }

  &::placeholder {
    color: var(--escala-de-cinza-40, #a3a3a3);
  }
`;

export const ModeToggle = styled.div`
  display: flex;
  gap: 4px;

  padding: 4px;

  border-radius: var(--radius-md, 8px);
  background: var(--escala-de-cinza-10, #efefef);
`;

export const ModeButton = styled.button<{ $active: boolean }>`
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  padding: 8px 12px;

  border: none;
  border-radius: 6px;
  cursor: pointer;

  font-family: Manrope;
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;

  background: ${({ $active }) => ($active ? 'var(--escala-de-cinza-0, #fff)' : 'transparent')};
  color: ${({ $active }) =>
    $active ? 'var(--Primary-Purple, #5768ff)' : 'var(--escala-de-cinza-60, #666)'};
  box-shadow: ${({ $active }) => ($active ? '0px 1px 3px 0px rgba(0, 0, 0, 0.12)' : 'none')};

  transition: all 0.2s ease;
`;

export const DrawToolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ToolbarSpacer = styled.div`
  flex: 1;
`;

export const ToolButton = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 36px;
  height: 36px;

  border-radius: var(--radius-md, 8px);
  border: 1px solid
    ${({ $active }) =>
      $active ? 'var(--Primary-Purple, #5768ff)' : 'var(--escala-de-cinza-20, #d6d6d6)'};
  background: ${({ $active }) =>
    $active ? 'rgba(87, 104, 255, 0.08)' : 'var(--escala-de-cinza-0, #fff)'};
  color: ${({ $active }) =>
    $active ? 'var(--Primary-Purple, #5768ff)' : 'var(--escala-de-cinza-60, #666)'};

  font-size: 16px;
  cursor: pointer;

  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    border-color: var(--Primary-Purple, #5768ff);
    color: var(--Primary-Purple, #5768ff);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const CanvasArea = styled.div<{ $visible: boolean }>`
  display: ${({ $visible }) => ($visible ? 'flex' : 'none')};
  flex: 1;
  min-height: 0;

  border-radius: var(--radius-md, 8px);
  border: 1px solid var(--escala-de-cinza-20, #d6d6d6);
  overflow: hidden;
`;

export const DrawCanvas = styled.canvas`
  display: block;
  width: 100%;
  height: 100%;

  background: var(--escala-de-cinza-0, #fff);
  cursor: crosshair;

  /* Desenhar dentro da área não dispara scroll nem gestos de navegação da página */
  touch-action: none;
  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
`;
